import * as yup from 'yup'
import { ReceiveCompanyPaymentMethod } from '../../types/companiesTypes'

export type ConnectedPersons = {
	idNumber?: string | null
	lastName?: string | null
	firstName?: string | null
}

const connectedPersonsSchema = yup.object({
	firstName: yup.string().nullable(),
	lastName: yup.string().nullable(),
	idNumber: yup.string().nullable(),
})

function checkConnectedPersons(this: yup.TestContext, items?: Array<ConnectedPersons>) {
	if (!Array.isArray(items)) return true

	const { receivePaymentMethod } = this.parent

	let errors = []

	const isValidField = (regex: RegExp, val?: string | null) => !!val && regex.test(val)

	if (receivePaymentMethod === String(ReceiveCompanyPaymentMethod.Cash)) {
		const firstPerson = items?.[0]

		if (!isValidField(/^/, firstPerson.firstName)) {
			errors.push(
				this.createError({
					path: 'connectedPersons[0].firstName',
					message: 'Please, fill in the field',
				}),
			)
		}

		if (!isValidField(/^/, firstPerson.lastName)) {
			errors.push(
				this.createError({
					path: 'connectedPersons[0].lastName',
					message: 'Please, fill in the field',
				}),
			)
		}

		if (!isValidField(/^/, firstPerson.idNumber)) {
			errors.push(
				this.createError({
					path: 'connectedPersons[0].idNumber',
					message: 'Please, fill in the field',
				}),
			)
		}
	}

	const secondPerson = items?.[1]
	const hasAny =
		!!secondPerson?.firstName || !!secondPerson?.lastName || !!secondPerson?.idNumber

	if (hasAny) {
		if (!isValidField(/^/, secondPerson.firstName)) {
			errors.push(
				this.createError({
					path: 'connectedPersons[1].firstName',
					message: 'Please, fill in the field',
				}),
			)
		}

		if (!isValidField(/^/, secondPerson.lastName)) {
			errors.push(
				this.createError({
					path: 'connectedPersons[1].lastName',
					message: 'Please, fill in the field',
				}),
			)
		}

		if (!isValidField(/^/, secondPerson.idNumber)) {
			errors.push(
				this.createError({
					path: 'connectedPersons[1].idNumber',
					message: 'Please, fill in the field',
				}),
			)
		}
	}

	return errors.length ? new yup.ValidationError(errors) : true
}

const companyForm = yup.object({
	companyName: yup
		.string()
		.typeError('No Valid')
		.trim()
		.required('Required Field')
		.matches(/^[0-9a-zA-Z-\s&]*$/, 'Please, enter a valid Company Name'),

	receivePaymentMethod: yup
		.string()
		.typeError('Please, select a payment method')
		.required('Please, select a payment method'),
	accountNumber: yup
		.string()
		.when('receivePaymentMethod', (receivePaymentMethod, field) =>
			receivePaymentMethod &&
			receivePaymentMethod === String(ReceiveCompanyPaymentMethod.Cash)
				? field
				: yup
						.string()
						.typeError('No Valid')
						.trim()
						.required('Required Field')
						.matches(/^[0-9a-zA-Z]*$/, 'Please, enter a valid Account Number'),
		),
	notificationEmail: yup
		.string()
		.typeError('Please, enter Email')
		.required('Required Field')
		.matches(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			'Please, enter a valid Email',
		),
	connectedPersons: yup
		.array()
		.of(connectedPersonsSchema)
		.test('checkingConnectedPersons', '', checkConnectedPersons),
})

export const companiesYupSchemes = {
	companyForm,
}
